export const AUTOCOMPLETE_SOURCES = {
	PLAYLISTS: 'playlists',
	COLLECTIONS: 'collections',
	AI_SEARCH: 'aiSearch',
	SUGGESTIONS: 'suggestions',
	FACETS: 'facets',
}

export const AUTOCOMPLETE_CONFIG = {
	MIN_FETCH_QUERY_LENGTH: 2, //Don't even open the typeahead until the user has typed 2+ trimmed characters
	CURATED_SECTION_MIN_QUERY_LENGTH: 3, //minimum query length before the panel adds the facets, playlists and collections sources on top of suggestions
	DEBOUNCE_DELAY: 400,
	MAX_CONSECUTIVE_ZERO_RESULT_REFINEMENTS: 2, //Stop fetching when the user keeps extending a query that already returned no results
	HITS_PER_PAGE: {
		SUGGESTIONS_AND_PROMPT: 3,
		COLLECTIONS: 3,
		PLAYLISTS: 3,
		FACETS: 3,
	},
	MIN_WORD_SIZE_FOR_1_TYPO: 6,
}
